import React from 'react';
import { useGDPRConsent } from '@/hooks/useGDPRConsent';
import { useAuthState } from '@/hooks/useAuthState';
import GDPRConsentDialog from './GDPRConsentDialog';

interface AuthWrapperProps {
  children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { user, loading: authLoading } = useAuthState();
  const { needsConsent, isLoading: consentLoading, giveConsent } = useGDPRConsent();

  // Show loading while checking auth or consent status
  if (authLoading || (user && consentLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If not authenticated, show children (login page)
  if (!user) {
    return <>{children}</>;
  }

  // If authenticated but needs consent, show GDPR dialog
  if (needsConsent) {
    return (
      <>
        {children}
        <GDPRConsentDialog 
          open={needsConsent} 
          onConsent={giveConsent}
          isLoading={consentLoading}
        />
      </>
    );
  }

  // If authenticated and has consent, show children
  return <>{children}</>;
};

export default AuthWrapper;